module.exports = __webpack_public_path__ + "media/src/images/abouts/cards/thanks/card-a0c301630a7e56dd035a34a6414c875a.jpg";